import React, { useRef, memo, useState, useEffect } from 'react';
import mb_reupload from '../../../images/icons/mb_upload.svg';
import pdfImage2 from '../../../images/pdfImage2.png';
import CircularLoading from '../CircularLoading/CircularLoading';
import ShowDoc from '../../../containers/CMDashboard/ShowDoc';
export const ShowGetImage = ({
  img,
  setEdit,
  editBtn = true,
  showInPopUP = false,
  passStyle = {}
}) => {
  const imgRef = useRef(null);
  const [file, setFile] = useState(false);
  const [show, setShow] = useState(false);
  return (
    <div className="relative w-44 h-37 mx-auto" style={passStyle}>
      {img ? (
        <div
          onClick={e => {
            if (showInPopUP) {
              setFile(img);
              setShow(true);
            } else if (img) {
              window.open(img, '_blank');
            }
          }}
          className="w-44 h-28 bg-white my-2 relative mx-auto cursor-pointer"
        >
          <img
            className="absolute object-cover w-full h-full"
            src={pdfImage2}
            alt="image"
          />
          {img ? (
            <img
              ref={imgRef}
              className="absolute z-10 w-full h-full object-cover "
              src={`${img}`}
              onError={() => imgRef.current.classList.add('hidden')}
              alt="image"
            />
          ) : (
            <CircularLoading />
          )}
        </div>
      ) : null}
      {editBtn ? (
        <div
          onClick={() => setEdit(true)}
          className="absolute z-50 top-0 right-0 -mt-3 -mr-4  cursor-pointer"
        >
          <img className="h-12 w-12" src={mb_reupload} alt="re-upload" />
        </div>
      ) : null}
      <ShowDoc file={file} show={show} setShow={setShow} autoCheck={true} />
    </div>
  );
};

export default memo(ShowGetImage);
